<template>
  <v-container>
    <v-container>
      <v-row>
        <v-col offset-md="2">
          <h2>Update Visual Data</h2>
          <router-link to="/admin">Back to Admin</router-link>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="4" sm="6" xs="12" offset-md="2">
          <v-select
            v-model="visualSelected"
            :items="visualRange"
            @change="loadVisual(visualSelected)"
            label="Visual #"
            outlined
            append-outer-icon="mdi-minus-circle"
            @click:append-outer="loadVisual(null)"
          ></v-select>
        </v-col>
        <v-col v-if="!!visualSelected && !visual">
          <v-btn
            color="primary"
            large
            @click="addVisual(visualSelected)">
            New Visual
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="!!visual">
      <v-row>
        <v-col md="6" xs="12" offset-md="2">
          <v-text-field
            :value="visual.fileName"
            @change="updateProperty('fileName', $event)"
            label="Filename"
            outlined
            autofocus></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6" xs="12" offset-md="2">
          <v-text-field
            :value="visual.forumLink"
            @change="updateProperty('forumLink', $event)"
            label="Forum Link"
            outlined
            autofocus></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6" xs="12" offset-md="2">
          <v-text-field
            :value="visual.thumbnailFileName"
            label="Thumbnail Filename"
            outlined
            autofocus></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6" xs="12" offset-md="2">
          <v-textarea
            :value="visual.description"
            @change="updateProperty('description', $event)"
            label="Description"
            outlined
            autofocus></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6" xs="12" offset-md="2">
          <v-switch
            :input-value="visual.found"
            @change="updateProperty('found', $event)"
            label="Found"
            color="success"
          ></v-switch>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6" xs="12" offset="2">
          <v-btn
            large
            color="success">
            Save
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { range } from 'lodash'

export default {
  name: 'VisualAdmin',
  data: () => ({
    visual: null,
    visualRange: range(1, 32),
    visualSelected: null,
  }),
  mounted: async function () {
    await this.$store.dispatch('visuals/bindVisuals')
  },
  methods: {
    loadVisual: function (visualNumber) {
      if (visualNumber) {
        this.visual = this.$store.getters['visuals/getVisualByNumber'](visualNumber)
      } else {
        this.visual = null
        this.visualSelected = null
      }
    },
    addVisual: function (number) {
      this.visual = {
        visualNumber: parseInt(number),
        fileName: `/assets/visuals/${number}.png`,
        thumbnailFileName: `/assets/visuals/thumbnails/${number}.png`,
        found: false,
      }
      this.$store.dispatch('visuals/addVisual', this.visual)
    },
    updateProperty: function (property, newVal) {
      this.$store.dispatch('visuals/updateVisualProperty', { visual: this.visual, property, newVal })
    },
    saveVisual: function (visual) {
      if (visual) {
        this.$store.dispatch('visuals/updateVisual', visual)
        console.log(this.visual)
      } else {
        this.visual = null
        this.visualSelected = null
      }
    },
  },
}
</script>

<style scoped>

</style>
